import React, { useState } from "react";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import PropTypes from "prop-types";
import clsx from "classnames";
import moment from "moment";

const DateInput = ({
  size,
  className,
  hasError,
  label,
  name,
  labelClassName,
  required = true,
  value,
  onChange,
  maxDate,
}) => {
  const [dateVal, setDateVal] = useState(
    new Date(value?.split("/").reverse().join("/"))
  );

  const datePickerBaseClass = "date-picker";

  const labelBaseClass = "pm-label";
  const labelClasses = clsx(labelBaseClass, labelClassName);

  const datePickerClasses = clsx(
    datePickerBaseClass,
    `${hasError ? `${datePickerBaseClass}--error` : ""}`,
    `${size ? `${datePickerBaseClass}--${size}` : ""}`,
    className
  );

  return (
    <div className="">
      {label && (
        <label htmlFor={name} className={labelClasses}>
          {label}
          {required && (
            <span style={{ marginLeft: ".2rem" }} className="font-danger">
              *
            </span>
          )}
        </label>
      )}
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          error={false}
          placeholder="dd/mm/yyyy"
          helperText={null}
          className={datePickerClasses}
          format="dd/MM/yyyy"
          id="date-picker-inline"
          value={dateVal}
          onChange={(val) => {
            setDateVal(val);
            onChange(moment(val).format("YYYY-MM-DD"));
          }}
          name={name}
          maxDate={maxDate}
          inputProps={{ readOnly: true }}
          // // autoOk={true}
          // PopoverProps={{
          //   // disableRestoreFocus: true,
          //   onClose: () => {
          //     setIsOpen(false);
          //   },
          // }}
          // InputProps={{
          //   onFocus: () => {
          //     setIsOpen(true);
          //   },
          // }}
          // open={isOpen}
        />
      </MuiPickersUtilsProvider>
    </div>
  );
};

DateInput.propTypes = {
  size: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  labelClasses: PropTypes.string,
  required: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DateInput;
